import { Pipe, PipeTransform } from '@angular/core';
import { BookingType, ExternalBookingType, TicketAirType } from "@afidium/ts-facade";
import { ExtractPricePipe } from "libraries/pipes/configurable-table/extract-price.pipe";
import { ExtractAgencyBookingPipe } from "libraries/pipes/configurable-table/extract-agency-booking.pipe";
import { DatePipe } from "@angular/common";
import { ComputeBookingLinkPipe } from "libraries/pipes/configurable-table/compute-booking-link";
import { BookingXStatus } from "libraries/component/booking/booking-status/booking-status.service";
import { LabelService } from "libraries/service/label/label.service";
import { Yii } from "libraries/interfaces/Yii";
import {
    IBookingSapeigBalance,
    IBookingSapeigBalancePriceDetail,
    IExternalBooking,
    IExternalBookingHost,
    IGetBookingsAirResponse,
    IGetBookingsCommonResponse,
    IGetBookingsStayResponse, IIdentityInfo,
    IRemark, IService, ITicket, ITraveller,
    TGetBookingResponse
} from "libraries/service/resources/booking/interfaces/IGetBookings";
import { ITotal } from "libraries/interfaces/ITotal";
import { IAirTotal } from "libraries/service/resources/model/search/air/IAirTotal";
import { PriceRealAmountPipe } from "libraries/pipes/price/priceRealAmount.pipe";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { EInterfaceValues } from "libraries/component/interface-flag/interface-flag.component";
import { IProcessReportBookingItem } from "libraries/interfaces/process-report/i-process-report-response";
import { ComputeValueHelperService } from "libraries/pipes/configurable-table/compute-value-helper.service";
import { FareOptimisationType } from "@afidium/ts-facade/model/fareOptimisationType";
import { DateService } from "libraries/date/date.service";
import { wenji } from "libraries/interfaces/IWenji";


export enum EConfigurableTableFields {
    AGENCY = "AGENCY",
    AGENT = "AGENT",
    AUTHOR = "AUTHOR",
    BEGIN = "BEGIN",
    BEGIN_END = "BEGIN_END",
    BOOKING = "BOOKING",
    BOOKING_COST = "BOOKING_COST",
    BOOKING_RETAIL = "BOOKING_RETAIL",
    BOOKING_STATUS = "BOOKING_STATUS",
    CARRIER = "CARRIER",
    CODE = "CODE",
    COST_TOTAL = "COST_TOTAL",
    CREATION_DATE = "CREATION_DATE",
    CREATION_FULL_DATE = "CREATION_FULL_DATE",
    CREATION_TIMESTAMP = "CREATION_TIMESTAMP",
    CUSTOMER = "CUSTOMER",
    CONSUMED = "CONSUMED",
    DOCUMENT = "DOCUMENT",
    END = "END",
    EXTERNAL_BOOKING = "EXTERNAL_BOOKING",
    FAKE_PADDING = "FAKE_PADDING",
    FROM = "FROM",
    FROM_TO = "FROM_TO",
    GDS_BOOKING = "GDS_BOOKING",
    HOST = "HOST",
    ISSUE_STATUS = "ISSUE_STATUS",
    LOCATION = "LOCATION",
    PAYMENT = "PAYMENT",
    PERSON = "PERSON",
    PRICE = "PRICE",
    PROCESS_TRAVELLER = "PROCESS_TRAVELLER",
    PROPERTY_NAME = "PROPERTY_NAME",
    QUALITY_CHECK_CONTENT = "QUALITY_CHECK_CONTENT",
    QUALITY_CHECK_TITLE = "QUALITY_CHECK_TITLE",
    REMARK = "REMARK",
    RETENTION = "RETENTION",
    ROOTING = "ROUTING",
    SEAT_STATUS = "SEAT_STATUS",
    SEARCH_FORM_PRICE = "SEARCH_FORM_PRICE",
    SECTOR = "SECTOR",
    SERVICE = "SERVICE",
    SYSCODE = "SYSCODE",
    TO = "TO",
    TRAVELLER = "TRAVELLER",
    TRAVELLER_QUANTITY = "TRAVELLER_QUANTITY",
    TICKET = "TICKET",
    TYPE = "TYPE",
    UP = "UP",
    WHEN_CREATED = "WHEN_CREATED",
    WHEN_TRAVEL_REALLY_BEGIN = "WHEN_TRAVEL_REALLY_BEGIN",
    WHEN_TO_ISSUE = "WHEN_TO_ISSUE",
    WORKFLOW_MESSAGE = "WORKFLOW_MESSAGE",
    WORKFLOW_STATUS = "WORKFLOW_STATUS",
    XSTATUS = "XSTATUS",
    XSTATUSEXTENDED = "XSTATUSEXTENDED",
    XTYPE = "XTYPE",
    INTERFACE = "INTERFACE",
    FARE_OPTIMISATION_SUMMARY = "FARE_OPTIMISATION_SUMMARY",
    FARE_OPTIMISATION_LIST = "FARE_OPTIMISATION_LIST",
}

interface IAmountCurrency {
    amount: number;
    currency: string;
}

export interface IFareOptimisationValue {
    fareOptimisation: FareOptimisationType;
    booking: BookingType;
}

export interface IValueType {
    value?: string | number | BookingXStatus | unknown | string[] |
        IStringWithLabel | ITextWithLabel | IFromToHyphen |
        IPriceDetail | IConsumedDetail | EInterfaceValues | IFareOptimisationValue;
    price?: IAmountCurrency;
    fareOptimisation?: FareOptimisationType;
    booking?: BookingType;
    type: "string" | "number" | "price" | 'xStatus' | 'processStatus' | 'seatStatusSector' | 'hostCode' | 'bookingType'
        | 'xStatusExtended' | 'qualityCheckTitle' | 'qualityCheckContent' | 'externalBooking' | 'remark' | 'sectorAir' |
        'sectorStay' | 'travellerQuantity' | 'searchPrice' | 'fakePadding' | 'issueStatus' | 'stringWithLabel' | 'textWithLabel' |
        'fromToHyphen' | 'valueWithName' | 'priceDetail' | 'consumedDetail' |
        'fareOptimisationSummary' | 'fareOptimisationList' |
        'interface';
    link?: string;
}

export interface IStringWithLabel {
    label?: string;
    value?: string;
}

export interface IPayment {
    paidPercentage?: number;
    pendingPercentage?: number;
    duePercentage?: number;
    paidValue?: string;
    pendingValue?: string;
    dueValue?: string;

}

export interface IPriceDetail {
    label?: string;
    value?: IPayment;

}

export interface ITextWithLabel {
    label?: string;
    value?: string;
}

export interface IValueWithName {
    label?: string;
    value?: string;
    name?: string;
}

export interface IFromToHyphen {
    from?: string;
    to?: string;
}

export interface IConsumed {
    issuedPercentage?: number;
    pendingPercentage?: number;
    usedPercentage?: number;
    issuedValue?: string;
    pendingValue?: string;
    usedValue?: string;

}

export interface IConsumedDetail {
    label?: string;
    value?: IConsumed;

}

class Wording {
    public created: string = Yii.t('wui-sasha-js', 'Date de création :');
    public by: string = Yii.t('wui-sasha-js', 'par');
    public emissionDate: string = Yii.t('wui-sasha-js', 'Date d\'émission');
    public individual: string = Yii.t('wui-sasha-js', 'Individuel');
    public group: string = Yii.t('wui-sasha-js', 'Groupe');
    public type: string = Yii.t('wui-sasha-js', 'Type');
    public syscode: string = Yii.t('wui-sasha-js', 'Syscode :');
    public traveller: string = Yii.t('wui-sasha-js', 'Voyageur :');
    public travellers: string = Yii.t('wui-sasha-js', 'Voyageurs :');
    public begin: string = Yii.t('wui-sasha-js', 'À partir du :');
    public end: string = Yii.t('wui-sasha-js', "Jusqu'au :");
    public ticket: string = Yii.t('wui-sasha-js', "Billet :");
    public tickets: string = Yii.t('wui-sasha-js', "Billets :");
    public note: string = Yii.t('wui-sasha-js', "Note :");
    public notes: string = Yii.t('wui-sasha-js', "Notes :");
    public passport: string = Yii.t('wui-sasha-js', "Passeport :");
    public passports: string = Yii.t('wui-sasha-js', "Passeports :");
    public services: string = Yii.t('wui-sasha-js', "Services :");
    public payment: string = Yii.t('wui-sasha-js', "Paiement :");
    public consumed: string = Yii.t('wui-sasha-js', "Voyagé :");
}

export type TComputeValueInput =
    TicketAirType
    | IProcessReportBookingItem
    | IGetBookingsCommonResponse
    | TGetBookingResponse;

@Pipe({
    name: 'computeValue'
})
export class ComputeValuePipe implements PipeTransform {
    public readonly wording: Wording = new Wording();

    private readonly dateFormat: string = JSON.parse(wenji.ui.dateFormat).momentShort;

    constructor(
        private readonly datePipe: DatePipe,
        private readonly extractAgencyBookingPipe: ExtractAgencyBookingPipe,
        private readonly extractPricePipe: ExtractPricePipe,
        private readonly computeBookingLinkPipe: ComputeBookingLinkPipe,
        private readonly labelService: LabelService,
        private readonly priceRealAmountPipe: PriceRealAmountPipe,
        private readonly computeValueHelperService: ComputeValueHelperService,
        private readonly dateService: DateService,
    ) {
    }

    // tslint:disable-next-line:cyclomatic-complexity
    public transform(element: TComputeValueInput, field: EConfigurableTableFields, path: string = null): IValueType {
        switch (field) {
            case EConfigurableTableFields.FAKE_PADDING:
                return {value: element, type: "fakePadding"};
            case EConfigurableTableFields.SYSCODE:
                return {value: {value: element.syscode, label: this.wording.syscode}, type: "stringWithLabel"};
            case EConfigurableTableFields.BEGIN:
                const beginDate: string = (element as IGetBookingsCommonResponse)?.begin || (element as IProcessReportBookingItem)?.beginDate;
                const formattedBegin: string = this.dateService.getDateFormatted(beginDate, this.dateFormat);
                return {value: {value: formattedBegin, label: this.wording.begin}, type: "stringWithLabel"};
            case EConfigurableTableFields.END:
                const endDate: string =(element as IGetBookingsCommonResponse)?.end || (element as IProcessReportBookingItem)?.endDate;
                const formattedEnd: string = this.dateService.getDateFormatted(endDate, this.dateFormat);
                return {value: {value: formattedEnd, label: this.wording.end}, type: "stringWithLabel"};
            case EConfigurableTableFields.CREATION_DATE:
            case EConfigurableTableFields.WHEN_CREATED:
                const whenCreated: string = (element as IGetBookingsCommonResponse)?.whenCreated ||
                    (element as IProcessReportBookingItem).whenCreatedDate;
                const formattedDate: string = this.dateService.getDateFormatted(whenCreated, this.dateFormat);
                return {value: {value: formattedDate, label: this.wording.created}, type: "stringWithLabel"};
            case EConfigurableTableFields.FROM_TO:
                return this.transformFromWithTo(element, path);
            case EConfigurableTableFields.REMARK:
                return this.transformRemark(element);
            case EConfigurableTableFields.SERVICE:
                return this.transformService(element);
            case EConfigurableTableFields.TICKET:
                return this.transformTicket(element);
            case EConfigurableTableFields.PAYMENT:
                return this.transformPayment(element);
            case EConfigurableTableFields.CONSUMED:
                return this.transformConsumed(element);
            case EConfigurableTableFields.TRAVELLER_QUANTITY:
                if ((element as IGetBookingsCommonResponse)?.traveller?.length) {
                    const travellerQuantity: number = (element as IGetBookingsCommonResponse)?.traveller?.length;
                    const label: string = travellerQuantity === 1 ? this.wording.traveller : this.wording.travellers;
                    return {
                        value: {value: travellerQuantity, label},
                        type: "stringWithLabel"
                    };
                }
                break;
            case EConfigurableTableFields.DOCUMENT:
                return this.transformDocument(element);
            case EConfigurableTableFields.AUTHOR:
            case EConfigurableTableFields.AGENT:
                return this.transformAuthor(element);
            case EConfigurableTableFields.PERSON:
            case EConfigurableTableFields.TRAVELLER:
                return {value: (element as TicketAirType).traveller?.name, type: "string"};
            case EConfigurableTableFields.TYPE:
                return {value: (element as IGetBookingsCommonResponse)?.type ?? 'noType', type: "bookingType"};
            case EConfigurableTableFields.CREATION_TIMESTAMP:
                return this.transformCreationTimestamp(element);
            case EConfigurableTableFields.PROCESS_TRAVELLER:
                return this.transformProcessTraveller(element);
            case EConfigurableTableFields.CODE:
                return this.transformCode(element);
            case EConfigurableTableFields.ISSUE_STATUS:
                return (element as IGetBookingsCommonResponse)?.issueStatus ? {
                    value: element,
                    type: 'issueStatus'
                } : null;
            case EConfigurableTableFields.BOOKING_STATUS:
            case EConfigurableTableFields.RETENTION:
            case EConfigurableTableFields.XSTATUS:
                return {value: `${(element as IProcessReportBookingItem).xStatus}`, type: "xStatus"};
            case EConfigurableTableFields.XSTATUSEXTENDED:
                return {value: `${(element as IProcessReportBookingItem).xStatus}`, type: "xStatusExtended"};
            case EConfigurableTableFields.WHEN_TO_ISSUE:
                return this.transformWhenToIssueDate(element);
            case EConfigurableTableFields.CREATION_FULL_DATE:
                return this.transformCreationFullDate(element);
            case EConfigurableTableFields.BEGIN_END:
                return this.transformBeginEnd(element);
            case EConfigurableTableFields.PROPERTY_NAME:
                return {
                    value: (element as IGetBookingsStayResponse)?.property?.length && (element as IGetBookingsStayResponse)?.property[0]?.name,
                    type: "string"
                };
            case EConfigurableTableFields.UP:
                return {value: (element as TicketAirType).sectorsCredited, type: "number"};
            case EConfigurableTableFields.GDS_BOOKING:
                return this.transformGDSBooking(element);
            case EConfigurableTableFields.AGENCY:
                return this.transformAgency(element);
            case EConfigurableTableFields.PRICE:
                return {
                    price: this.extractPricePipe.transform((element as TicketAirType).price), type: "price"
                };
            case EConfigurableTableFields.SEARCH_FORM_PRICE:
            case EConfigurableTableFields.COST_TOTAL:
            case EConfigurableTableFields.BOOKING_COST:
            case EConfigurableTableFields.BOOKING_RETAIL:
                return {
                    value: (element as IGetBookingsCommonResponse), type: "searchPrice"
                };
            case EConfigurableTableFields.WORKFLOW_STATUS:
                return {value: (element as IProcessReportBookingItem).workflowStatus?.status, type: "processStatus"};
            case EConfigurableTableFields.WORKFLOW_MESSAGE:
                return {value: (element as IProcessReportBookingItem).workflowStatus?.message, type: "string"};
            case EConfigurableTableFields.HOST:
                return (element as IGetBookingsCommonResponse)?.host ? {
                    value: (element as IGetBookingsCommonResponse).host,
                    type: 'string'
                } : null;
            case EConfigurableTableFields.BOOKING:
                return this.transformBooking(element);
            case EConfigurableTableFields.CARRIER:
                return (element as IGetBookingsCommonResponse)?.carrier?.name ? {
                    value: (element as IGetBookingsCommonResponse)?.carrier?.name,
                    type: "string"
                } : null;
            case EConfigurableTableFields.FROM:
            case EConfigurableTableFields.TO:
                return this.transformFromTo(element, path);
            case  EConfigurableTableFields.QUALITY_CHECK_CONTENT :
                return (element as IGetBookingsCommonResponse).booking?.qualityCheck ? {
                    value: element,
                    type: 'qualityCheckContent'
                } : null;
            case  EConfigurableTableFields.QUALITY_CHECK_TITLE:
                return (element as IGetBookingsCommonResponse).booking?.qualityCheck ? {
                    value: element,
                    type: 'qualityCheckTitle'
                } : null;
            case  EConfigurableTableFields.EXTERNAL_BOOKING :
                const value: IExternalBooking[] = (element as IGetBookingsCommonResponse).booking?.externalBookingArray
                    || (element as IGetBookingsAirResponse).externalBooking;
                return value ? {value, type: 'externalBooking'} : null;
            case  EConfigurableTableFields.WHEN_TRAVEL_REALLY_BEGIN :
                return this.transformDate(element, path);
            case  EConfigurableTableFields.SECTOR:
            case  EConfigurableTableFields.LOCATION:
                return this.transformSector(element);
            case  EConfigurableTableFields.SEAT_STATUS:
                return path && element[path] ? {value: element, type: 'seatStatusSector'} : null;
            case  EConfigurableTableFields.XTYPE:
                return path && element[path] ? this.transformXType(element) : null;
            case  EConfigurableTableFields.CUSTOMER:
                return this.transformCustomer(element, path);
            case EConfigurableTableFields.FARE_OPTIMISATION_SUMMARY:

                return this.computeValueHelperService.transformFareOptimisation(
                    (element as IGetBookingsAirResponse),
                    "summary"
                );
            case EConfigurableTableFields.FARE_OPTIMISATION_LIST:
                return this.computeValueHelperService.transformFareOptimisation(
                    (element as IGetBookingsAirResponse),
                    "list"
                );
            case  EConfigurableTableFields.INTERFACE:
                if((element as IGetBookingsCommonResponse).booking?.externalBookingArray?.length) {
                    const externalBookingWithInterface: IExternalBooking = (element as IGetBookingsCommonResponse).booking?.externalBookingArray
                        .find((item: IExternalBooking): boolean => {
                            return Boolean(item.interface) || Boolean(
                                Boolean(item.host)
                                && typeof item.host !== "string"
                                && (item.host as IExternalBookingHost).interface
                            );
                        });
                    const interfaceValue: EInterfaceValues = externalBookingWithInterface
                        && (externalBookingWithInterface?.host as IExternalBookingHost)?.interface?.name;
                    return interfaceValue
                        ? {
                            value: interfaceValue,
                            type: 'interface'
                        }
                        : null;
                }
                return null;
            default:
                /*if (path) {
                    const value: string = this.readValueFromPath(element, path);
                    return value ? {value, type: 'string'} : null;
                }*/
                return null;
        }
    }

    private transformPayment(element: TComputeValueInput): IValueType {
        const response: IGetBookingsCommonResponse = element as IGetBookingsCommonResponse;
        const sapeigBalance: IBookingSapeigBalance = response?.sapeigBalance;

        if (sapeigBalance) {
            const details: IBookingSapeigBalancePriceDetail[] = sapeigBalance.details;

            if (details && details.length > 0) {
                const detailIndex: number = details.findIndex((detail: IBookingSapeigBalancePriceDetail): boolean =>
                    detail.due !== undefined && detail.totalExpected !== undefined
                );

                if (detailIndex !== -1) {
                    const detail: IBookingSapeigBalancePriceDetail = details[detailIndex];
                    const dueValue: number = detail.due;
                    const totalExpected: number = detail.totalExpected;
                    const decimals: number = detail.decimals;
                    const currency: string = detail.currency;
                    const paidValue: number = totalExpected - dueValue;
                    const pendingValue: number = Math.max(0, totalExpected - paidValue);
                    const numericDueValue: number = dueValue / Math.pow(10, decimals);
                    const numericPaidValue: number = paidValue / Math.pow(10, decimals);
                    const numericPendingValue: number = pendingValue / Math.pow(10, decimals);
                    const formattedDueValue: SafeHtml = this.priceRealAmountPipe.transform(numericDueValue, currency);
                    const formattedPaidValue: SafeHtml = this.priceRealAmountPipe.transform(numericPaidValue, currency);
                    const formattedPendingValue: SafeHtml = this.priceRealAmountPipe.transform(numericPendingValue, currency);
                    const duePercentage: number = Math.floor((dueValue / totalExpected) * 100);
                    const paidPercentage: number = Math.floor((paidValue / totalExpected) * 100);
                    const pendingPercentage: number = Math.floor((pendingValue / totalExpected) * 100);

                    return {
                        value: {
                            label: this.wording.payment,
                            value: {
                                paidPercentage,
                                pendingPercentage,
                                duePercentage,
                                paidValue: formattedPaidValue,
                                pendingValue: formattedPendingValue,
                                dueValue: formattedDueValue
                            }
                        },
                        type: 'priceDetail'
                    };
                }
            }
        }

        return null;
    }

    private transformConsumed(element: TComputeValueInput): IValueType {
        const response: IGetBookingsCommonResponse = element as IGetBookingsCommonResponse;
        const issuedValueDataArray: IAirTotal[] = response?.total;

        if (issuedValueDataArray?.length) {
            const issuedValue: ITotal[] = issuedValueDataArray?.map((due: IAirTotal): ITotal => due?.history);

            if (issuedValue) {
                const issuedHistoryIndex: number = issuedValue?.findIndex((data: ITotal): ITotal => data);
                const issuedValueData: number = issuedValue?.[issuedHistoryIndex]?.issuedValue;
                const issuedDecimals: number = issuedValue?.[issuedHistoryIndex]?.decimals;
                const currency: string = issuedValue?.[issuedHistoryIndex]?.currency;

                const usedValueDataArray: IAirTotal[] = response?.total;
                const usedValue: ITotal[] = usedValueDataArray?.map((due: IAirTotal): ITotal => due?.history);
                const usedHistoryIndex: number = usedValue?.findIndex((data: ITotal): ITotal => data);
                const usedValueData: number = usedValue?.[usedHistoryIndex]?.usedValue;
                const usedDecimals: number = usedValue?.[usedHistoryIndex]?.decimals;

                const pendingValueDataArray: IAirTotal[] = (element as IGetBookingsCommonResponse)?.total;
                const pendingValueData: ITotal[] = pendingValueDataArray?.map((pendingData: IAirTotal): ITotal => pendingData?.history);
                const pendingHistoryIndex: number = pendingValueData?.findIndex((data: ITotal): ITotal => data);
                const pendingValue: number = pendingValueData?.[pendingHistoryIndex]?.pendingValue;
                const pendingDecimals: number = pendingValueData?.[pendingHistoryIndex]?.decimals;

                const pendingPercentageDataArray: IAirTotal[] = (element as IGetBookingsCommonResponse).total;
                const pendingPercentageData: ITotal[] = pendingPercentageDataArray?.map((percentage: IAirTotal): ITotal => percentage?.history);
                const pendingPercentageHistoryIndex: number = pendingPercentageData?.findIndex((data: ITotal): ITotal => data);
                const pendingPercentage: number = pendingPercentageData?.[pendingPercentageHistoryIndex]?.pendingPercentage;

                const usedPercentageDataArray: IAirTotal[] = (element as IGetBookingsCommonResponse)?.total;
                const usedPercentageData: ITotal[] = usedPercentageDataArray?.map((percentage: IAirTotal): ITotal => percentage?.history);
                const usedPercentageHistoryIndex: number = usedPercentageData?.findIndex((data: ITotal): ITotal => data);
                const usedPercentage: number = usedPercentageData?.[usedPercentageHistoryIndex]?.usedPercentage;


                let formattedUsedValue: SafeHtml;
                let formattedPendingValue: SafeHtml;
                let formattedIssuedValue: SafeHtml;

                if (issuedValueData !== undefined && issuedDecimals !== undefined) {
                    const issuedNumericValue: number = issuedValueData / Math.pow(10, issuedDecimals);
                    formattedIssuedValue = this.priceRealAmountPipe.transform(issuedNumericValue, currency);
                }

                if (usedValueData !== undefined && usedDecimals !== undefined) {
                    const usedNumericValue: number = usedValueData / Math.pow(10, usedDecimals);
                    formattedUsedValue = this.priceRealAmountPipe.transform(usedNumericValue, currency);
                }

                if (pendingValue !== undefined && pendingDecimals !== undefined) {
                    const pendingNumericValue: number = pendingValue / Math.pow(10, pendingDecimals);
                    formattedPendingValue = this.priceRealAmountPipe.transform(pendingNumericValue, currency);
                }

                return {
                    value: {
                        label: this.wording.consumed,
                        value: {
                            usedPercentage,
                            pendingPercentage,
                            usedValue: formattedUsedValue,
                            pendingValue: formattedPendingValue,
                            issuedValue: formattedIssuedValue
                        }
                    },
                    type: 'consumedDetail'
                };
            }
        }
        return null;
    }

    private transformDocument(element: TComputeValueInput): IValueType {
        const response: IGetBookingsCommonResponse = element as IGetBookingsCommonResponse;

        if (response?.traveller?.length) {
            const passportArray: ITraveller[] = response?.traveller;
            const passportNumbers: string[] = passportArray?.flatMap((traveller: ITraveller): string[] =>
                (traveller?.passport || []).map((identityInfo: IIdentityInfo): string => identityInfo?.number));
            const passportNames: string[] = passportArray?.flatMap((traveller: ITraveller): string[] =>
                (traveller?.passport || []).map((): string => `${traveller?.firstName} ${traveller?.lastName}`));

            if (passportNumbers?.length > 0) {
                const documentLabel: string = passportNames?.length === 1 ? this.wording.passport : this.wording.passports;

                return {
                    value: {
                        value: passportNumbers,
                        label: documentLabel,
                        name: passportNames
                    },
                    type: "valueWithName"
                };
            }
        }

        return {value: {}, type: "stringWithLabel"};
    }

    private transformRemark(element: TComputeValueInput): IValueType {
        const notes: IRemark[] = (element as IGetBookingsCommonResponse)?.note;
        const noteValues: string[][][] = notes && notes.length > 0 ? notes.map((note: IRemark): string[][] => [note.text]) : [];
        const remarkLabel: string = noteValues.length === 1 ? this.wording.note : this.wording.notes;

        return {
            value: notes && notes.length > 0 ? {label: remarkLabel, value: noteValues} : null,
            type: 'textWithLabel'
        };
    }

    private transformTicket(element: TComputeValueInput): IValueType {
        const ticketArray: ITicket[] = (element as IGetBookingsCommonResponse)?.ticketNewArray;
        const ticketValues: string[] = ticketArray && ticketArray.length > 0 ? ticketArray.map((ticket: ITicket): string => ticket.number) : [];
        const ticketNames: string[] = ticketArray && ticketArray.length > 0 ? ticketArray.map((ticket: ITicket): string => `${ticket.traveller.firstName} ${ticket.traveller.lastName}`) : [];
        const ticketLabel: string = ticketValues.length === 1 ? this.wording.ticket : this.wording.tickets;

        return {
            value: ticketArray && ticketArray.length > 0 ? {
                value: ticketValues,
                label: ticketLabel,
                name: ticketNames
            } : null,
            type: 'valueWithName'
        };
    }

    private transformService(element: TComputeValueInput): IValueType {
        const serviceArray: IService[] = (element as IGetBookingsCommonResponse)?.service || [];
        const serviceQuantityArray: { [serviceName: string]: number } = {};

        serviceArray.forEach((service: IService): void => {
            const serviceName: string = service.name;
            serviceQuantityArray[serviceName] = (serviceQuantityArray[serviceName] || 0) + 1;
        });

        const serviceNames: string[] = Object.keys(serviceQuantityArray);
        const serviceQuantity: string[] = Object.keys(serviceQuantityArray)
            .map((serviceName: string): string => `x${serviceQuantityArray[serviceName]}`);

        if (serviceNames.length === 0) {
            return {value: {}, type: 'textWithLabel'};
        }

        return {
            value: {
                value: serviceNames,
                label: this.wording.services,
                name: serviceQuantity
            },
            type: 'valueWithName'
        };
    }

    private transformXType(element: TComputeValueInput): IValueType {
        const xTypeTranslate: string = (element as IGetBookingsCommonResponse)?.xType === 'group' ? this.wording.group : this.wording.individual;
        return {value: `${this.wording.type}: ${xTypeTranslate}`, type: 'string'};
    }

    private transformSector(element: TComputeValueInput): IValueType {
        const type: string = (element as TGetBookingResponse).type?.length ? (element as TGetBookingResponse).type[0] : null;
        if (type === 'air') {
            return {value: element, type: 'sectorAir'};
        }
        return null;
    }

    private transformFromTo(element: TComputeValueInput, path: string): IValueType {
        if ((path === 'from' || path === 'to') && element[path]) {
            const value: string = `${element[path].city?.name}`;
            return {value, type: 'string'};
        }
        return null;
    }

    private transformFromWithTo(element: TComputeValueInput, path: string): IValueType {
        if ((path === 'from' || path === 'to') && element[path]) {
            const fromValue: string = (element as IGetBookingsAirResponse).from?.city?.name;
            const toValue: string = (element as IGetBookingsAirResponse).to?.city?.name;

            if (fromValue && toValue) {
                return {value: {from: fromValue, to: toValue}, type: 'fromToHyphen'};
            }
        }

        return null;
    }

    private readValueFromPath(element: TComputeValueInput, path: string): string {
        // TODO create extract from path and split string by dot
        return element[path] ?? null;
    }

    private transformAgency(element: TComputeValueInput): IValueType {
        if ((element as TicketAirType).agency) {
            return {value: (element as TicketAirType).agency.code, type: "string"};
        }
        return null;
    }

    private transformBooking(element: TComputeValueInput): IValueType {
        const booking: ExternalBookingType = this.extractAgencyBookingPipe.transform((element as TicketAirType).booking);
        return booking ? {value: booking.code, type: "string"} : null;
    }

    private transformCustomer(element: TComputeValueInput, path: string): IValueType {
        if (element[path] && element[path].firstName && element[path].lastName) {
            return {
                value: `${element[path].firstName} ${element[path].lastName}`,
                type: 'string'
            };
        } else if (element.traveller && element.traveller[0]?.firstName && element.traveller[0]?.lastName) {
            return {
                value: `${element.traveller[0].firstName} ${element.traveller[0].lastName}`,
                type: 'string'
            };
        }
        return null;
    }

    private transformGDSBooking(element: TComputeValueInput): IValueType {
        if ((element as TicketAirType).booking) {
            return {
                value: (element as TicketAirType).booking.code,
                type: "string",
                link: this.computeBookingLinkPipe.transform((element as TicketAirType))
            };
        }
        return null;
    }

    private transformBeginEnd(element: TComputeValueInput): IValueType {
        if ((element as IProcessReportBookingItem).beginDate && (element as IProcessReportBookingItem).endDate) {
            return {
                value: this.labelService.completeLabel(
                    Yii.t('wui-shared-js', 'du %begin% au %end%'),
                    {
                        begin: this.datePipe.transform(
                            (element as IProcessReportBookingItem).beginDate,
                            'shortDate',
                        ),
                        end: this.datePipe.transform(
                            (element as IProcessReportBookingItem).endDate,
                            'shortDate',
                        ),
                    }
                ),
                type: 'string',
            };
        }
        if ((element as IGetBookingsCommonResponse).begin && (element as IGetBookingsCommonResponse).end) {
            return {
                value: this.labelService.completeLabel(
                    Yii.t('wui-shared-js', 'du %begin% au %end%'),
                    {
                        begin: this.datePipe.transform(
                            (element as IGetBookingsCommonResponse).begin,
                            'shortDate',
                        ),
                        end: this.datePipe.transform(
                            (element as IGetBookingsCommonResponse).end,
                            'shortDate',
                        ),
                    }
                ),
                type: 'string',
            };
        }
        return null;
    }

    private transformAuthor(element: TComputeValueInput): IValueType {
        if ((element as TicketAirType).actionArray?.length) {
            const value: string = (element as TicketAirType).actionArray[0].agent ?
                (element as TicketAirType).actionArray[0].agent.name || ((element as TicketAirType).actionArray[0].agent.code as string) :
                (element as TicketAirType).actionArray[0].who;
            return value ? {value, type: 'string'} : null;
        }
        if ((element as IGetBookingsCommonResponse)?.agent) {
            const lastName: string = (element as IGetBookingsCommonResponse).agent.lastName;
            const firstName: string = (element as IGetBookingsCommonResponse).agent.firstName;
            return {
                value: `${this.wording.by} ${lastName} ${firstName}`,
                type: 'string',
            };
        }
        return null;
    }

    private transformCreationTimestamp(element: TComputeValueInput): IValueType {
        const value: string = (element as IProcessReportBookingItem).whenCreatedTimestamp ?
            (element as IProcessReportBookingItem).whenCreatedTimestamp : (element as IGetBookingsCommonResponse).whenCreated;
        return {value, type: "string"};
    }

    private transformCreationFullDate(element: TComputeValueInput): IValueType {
        return {
            value: `${this.datePipe.transform(
                (element as unknown as IProcessReportBookingItem).whenCreatedDate as string | number | Date,
                'shortDate',
            )} ${this.datePipe.transform(
                (element as unknown as IProcessReportBookingItem).whenCreatedDate as string | number | Date,
                'mediumTime',
            )}`,
            type: 'string',
        };
    }

    private transformCreationDate(element: TComputeValueInput): IValueType {
        return {
            value: `${this.wording.created} ${this.datePipe.transform(
                (element as IProcessReportBookingItem).whenCreatedDate ?? (element as IGetBookingsCommonResponse).whenCreated,
                'shortDate',
            )}`,
            type: 'string',
        };
    }

    private transformWhenToIssueDate(element: TComputeValueInput): IValueType {
        return (element as IGetBookingsCommonResponse)?.whenToIssue ? {
            value: `${this.wording.emissionDate}: ${this.datePipe.transform(
                (element as IGetBookingsCommonResponse)?.whenToIssue,
                'shortDate',
            )}`,
            type: 'string',
        } : null;
    }

    private transformCode(element: TComputeValueInput): IValueType {
        if ((element as IProcessReportBookingItem)?.hostCode) {
            return {
                value: `${(element as unknown as IProcessReportBookingItem).hostCode} ${element.code}`,
                type: "hostCode"
            };
        }
        return {
            value: `${element.code}`,
            type: "hostCode"
        };
    }

    private transformProcessTraveller(element: TComputeValueInput): IValueType {
        if ((element as TicketAirType).traveller?.firstName) {
            return {
                value: `${(element as TicketAirType).traveller?.firstName} ${(element as TicketAirType).traveller?.lastName}`,
                type: "string"
            };
        }
        return null;
    }

    private transformDate(element: TComputeValueInput, path: string = null, date: string = null, format: string = 'shortDate'): IValueType {
        return this.computeValueHelperService.transformDate(element, path, date, format);
    }

    private transformBegin(element: TComputeValueInput): IValueType {
        return {
            value: this.datePipe.transform(
                (element as TicketAirType).begin?.date,
                'shortDate',
            ),
            type: 'string',
        };
    }

    private transformEnd(element: TComputeValueInput): IValueType {
        return {
            value: this.datePipe.transform(
                // @ts-ignore
                element.end?.date,
                'shortDate',
            ),
            type: 'string',
        };
    }

    private capitalizeFirstLetter(string: string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
}
